const CHUNK_URL = /(?:https?:\/\/[^\s'"]+)?\/_nuxt\/[^\s'"]+?\.(?:m?js|css)/
const RELOAD_KEY = 'reload-count'
const RELOAD_WINDOW_MS = 60_000
const REFRESH_TIMEOUT_MS = 3_000

function getChunkUrl(error: unknown) {
  const match = error instanceof Error ? error.message.match(CHUNK_URL)?.[0] : undefined
  return match ? new URL(match, window.location.href).href : undefined
}

async function refreshChunk(error: unknown) {
  const url = getChunkUrl(error)
  if (!url) return

  // Bust the potentially poisoned cache entry
  const refresh = fetch(url, { cache: 'reload' }).then(response => response.arrayBuffer())
  const timeout = new Promise(resolve => setTimeout(resolve, REFRESH_TIMEOUT_MS))

  try {
    await Promise.race([refresh, timeout])
  } catch {
    // The page reload still runs
  }
}

function reloadPage() {
  const [count = 0, at = 0] = (sessionStorage.getItem(RELOAD_KEY) ?? '').split(':').map(Number)
  const reloadCount = Date.now() - at < RELOAD_WINDOW_MS ? count : 0

  if (reloadCount >= 2) {
    // Most likely an ancient browser, so we won't waste our breath further
    return
  }

  sessionStorage.setItem(RELOAD_KEY, `${reloadCount + 1}:${Date.now()}`)

  try {
    const url = URL.parse(window.location.href)!

    url.searchParams.set('force-reload', Date.now().toString())
    window.location.href = url.toString()
  } catch {
    window.location.reload()
  }
}

export default defineNuxtPlugin({
  name: 'error-handling',
  hooks: {
    async 'app:chunkError'({ error }) {
      await refreshChunk(error)
      reloadPage()
    },
  },
})
